// @flow
// $FlowFixMe[cannot-resolve-module]
import { useMutation, useQueryClient } from 'react-query';
import { toastr } from 'react-redux-toastr';
import FileSaver from 'file-saver';

import DocumentService from '../../../services/documentService';

type GenerateLetterParams = {
  applicationId?: string,
  residentId?: string,
  residentLetterId: string,
  filename: string,
  organizationId?: string,
  propertyId?: string,
};

type UseGenerateResidentLetterOptions = {
  onSuccess?: (data: any, variables: GenerateLetterParams) => void,
  onError?: (error: any) => void,
};

export const useGenerateResidentLetter = (
  options: UseGenerateResidentLetterOptions = {},
): any => {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: GenerateLetterParams) => {
      const documentService = new DocumentService();
      return documentService.saveResidentLetter(
        {
          applicationId: params.applicationId,
          residentId: params.residentId,
        },
        params.residentLetterId,
        params.organizationId,
        params.propertyId,
      );
    },
    {
      onSuccess: (data, variables) => {
        FileSaver.saveAs(data, variables.filename);
        toastr.success('Letter generated successfully');
        queryClient.invalidateQueries(['documents']);
        options.onSuccess?.(data, variables);
      },
      onError: (error) => {
        toastr.error('Failed to generate letter');
        options.onError?.(error);
      },
    },
  );
};
